import { useMsal } from '@azure/msal-react';
import { IconLogout } from '@tabler/icons-react';

import { Button } from '@mantine/core';

import { logoutRequest } from '../../authConfig';

export const LogOutButton = () => {
    const { instance: msal } = useMsal();

    const handleLogout = () => {
        msal.logoutRedirect(logoutRequest).catch(error => console.log(error));
    };

    return (
        <Button
            onClick={handleLogout}
            leftSection={<IconLogout size={16} />}
            variant='subtle'
            color='gray'
            size='xs'
        >
            Log Out
        </Button>
    );
};
